import { formatDate, formatRelativeDay } from "@/lib/dates";

import type { DealStage, LabeledValue } from "../types";

export const findDealLabel = (dealStages: DealStage[], dealValue: string) => {
  const dealStage = dealStages.find((stage) => stage.value === dealValue);
  return dealStage?.label;
};

export const formatDealCategories = (
  dealCategories: LabeledValue[],
  categories: string[] | null | undefined,
): string =>
  (categories ?? [])
    .map(
      (value) => dealCategories.find((c) => c.value === value)?.label ?? value,
    )
    .join(", ");

/** "Hoy", "Hace 3 días" within a week, "31 de octubre" beyond. */
export function getRelativeTimeString(
  dateString: string,
  locale = "es",
): string {
  return formatRelativeDay(dateString, locale);
}

const isoDateStringRegex = /^\d{4}-\d{2}-\d{2}$/;

export function formatISODateString(dateString: string, locale = "es") {
  if (!isoDateStringRegex.test(dateString)) {
    throw new Error("Invalid date format. Expected YYYY-MM-DD.");
  }
  // formatDate reads YYYY-MM-DD as a local day (never UTC midnight), so the
  // date does not shift by one day depending on the user's timezone.
  return formatDate(dateString, locale);
}
